<template>
    <div class="trainer">
        <div class="trainer__image" :class="{'trainer__image--more' : !trainer}">
            <v-lazy-image :src="trainer.coverImageUrl ? trainer.coverImageUrl : trainer.profileImageUrl" v-if="trainer.coverImageUrl || trainer.profileImageUrl"></v-lazy-image>

            <img alt="PUMATRAC" src="../assets/trac-logo-light.svg" v-if="!trainer" />
            <Icon name="arrow-right" v-if="!trainer"></Icon>
        </div>
        <div class="trainer__name text text--large">
            <span v-if="trainer.title || trainer.name">{{trainer.title ? trainer.title : trainer.name}}</span>
            <span v-else v-translate>find_more</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        trainer: {
            type: [Object, Boolean],
        }
    }
}
</script>

<style lang="scss" scoped>
.trainer {
    &__image {
        position: relative;
        width: 100%;
        border-radius: 100%;
        overflow: hidden;

        &:after {
            content: '';
            display: block;
            padding-bottom: 100%;
        }

        img {
            @include object-fit;
            border-radius: 100%;
        }

        &--more {
            background: black;

            img {
                object-fit: contain;
                width: 74%;
                left: 13%;
            }

            .icon {
                position: absolute;
                left: 50%;
                top: 75%;
                transform: translateX(-50%);
                z-index: 3;
                color: white;
            }
        }
    }

    &__name {
        margin: 20px 0 0;
        text-align: center;
    }
}
</style>